/**
 * Reusable form primitives for Journey lead forms.
 */
export function Field({ label, hint, required, children, testId }) {
  return (
    <label data-testid={testId} className="block space-y-1.5">
      <span className="text-[11px] font-medium uppercase tracking-[0.18em] text-zinc-400">
        {label}
        {required ? <span className="ml-0.5 text-emerald-400">*</span> : null}
      </span>
      {children}
      {hint ? <span className="block text-[11px] text-zinc-500">{hint}</span> : null}
    </label>
  );
}

export const inputClass =
  "w-full rounded border border-white/10 bg-[#0B0F10] px-3 py-2 text-sm text-zinc-100 outline-none transition focus:border-emerald-500/40";

export const textareaClass = `${inputClass} min-h-[100px] resize-y leading-relaxed`;

export function FieldRow({ children }) {
  return <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">{children}</div>;
}

export function FormSection({ title, subtitle, children, testId }) {
  return (
    <section
      data-testid={testId}
      className="space-y-4 rounded-md border border-white/[0.06] bg-white/[0.01] p-5"
    >
      <header className="space-y-1">
        <h2 className="text-sm font-semibold text-zinc-100">{title}</h2>
        {subtitle ? <p className="text-xs text-zinc-500">{subtitle}</p> : null}
      </header>
      <div className="space-y-4">{children}</div>
    </section>
  );
}
